import { render, staticRenderFns } from "./NanCarousel.vue?vue&type=template&id=7f08450a"
import script from "./NanCarousel.vue?vue&type=script&lang=js"
export * from "./NanCarousel.vue?vue&type=script&lang=js"
import style0 from "./NanCarousel.vue?vue&type=style&index=0&id=7f08450a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports